module.exports = __webpack_public_path__ + "static/media/pile-of-coins.e52d9a9c.png";